import React from "react";
import {ThemeProvider} from "@material-ui/core";
import {App} from "./app";
import {store} from "./redux/store";
import {Provider} from "react-redux";
import './localization';
import {
  TaskQueueProvider,
  ViewerProvider,
  ActiveToolProvider,
  AuthProvider
} from "./providers";
import { createTheme } from "./theme";
import { GlobalSettingsProvider } from "./providers/global-settings-provider";

const theme = createTheme();

const EngineViewer = () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <ViewerProvider>
          <GlobalSettingsProvider>
            <TaskQueueProvider>
              <ActiveToolProvider>
                <AuthProvider>
                  <App/>
                </AuthProvider>
              </ActiveToolProvider>
            </TaskQueueProvider>
          </GlobalSettingsProvider>
        </ViewerProvider>
      </ThemeProvider>
    </Provider>
  );
};

export default EngineViewer;